import { render, staticRenderFns } from "./treeAttrDlg.vue?vue&type=template&id=b356f29c&scoped=true&"
import script from "./treeAttrDlg.vue?vue&type=script&lang=js&"
export * from "./treeAttrDlg.vue?vue&type=script&lang=js&"
import style0 from "./treeAttrDlg.vue?vue&type=style&index=0&id=b356f29c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b356f29c",
  null
  
)

export default component.exports